import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { Library, LibraryPayload } from 'icreate/common/models/library';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LibraryService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getByShipyardId(shipyardId: string) {
        return await lastValueFrom(
            this.http.get<Library[]>(`${this.domain}/api/library`, {
                headers: this.headers,
                params: { shipyardId },
            })
        );
    }

    async create(libraryData: LibraryPayload) {
        return await lastValueFrom(
            this.http.post<Library>(`${this.domain}/api/library`, libraryData, {
                headers: this.headers,
            })
        );
    }

    async update(libraryData: Library) {
        return await lastValueFrom(
            this.http.put(`${this.domain}/api/library/${libraryData.id}`, libraryData, {
                headers: this.headers,
            })
        );
    }

    async deleteLibrary(libraryId: string) {
        return await lastValueFrom(this.http.delete(`${this.domain}/api/library/${libraryId}`));
    }

    async duplicateLibrary(libraryData: Library) {
        return await lastValueFrom(
            this.http.post<Library>(`${this.domain}/api/library/duplicate`, libraryData, {
                headers: this.headers,
            })
        );
    }
}
